<app-navigation>


        <app-fahrtenbuch-form *ngIf="showFormStatus" (showTable)="showTable()" [entryId]="formEntryId"></app-fahrtenbuch-form>
        <app-fahrtenbuch-table *ngIf="showTableStatus"  (editEntry)="editEntry($event)"></app-fahrtenbuch-table>        

        
</app-navigation>
